// Achors loader
const anchors = function() {
		var goto;
        if ( '' !== window.location.hash ) {
			goto = window.location.hash.substring( 1 );

            let coord = document.getElementById( goto );
            if ( coord ) {
                jQuery( 'html, body' ).animate({ scrollTop: coord.offsetTop - 100 }, 200 );
            }
    }
};

// Export
export default anchors;
